import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { Box, Grid, Typography } from '@material-ui/core';

import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import VehicleCards from '../../../components/VehicleCards/VehicleCards.component';
import VehicleList from '../../../components/VehicleList/VehicleList.component';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../context/sidebar/sidebar.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../query/vehicles/vehicles';

const Endorsements = () => {
  const { data: vehicles, isLoading: loading } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );
  const { user } = useAuthDataContext();
  const { setStepperTitle, setStep } = useSidebarContext();

  useEffect(() => {
    dataLayerPush('inicio_modificar_poliza', user?.id);
    dataLayerPush('modificar_poliza_consulta', user?.id);
    setStepperTitle();
  }, [setStepperTitle, user]);

  const history = useHistory();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action="Cargando vehículos" />
      </Box>

      <StepperSubHeader goBack={() => history.goBack()}></StepperSubHeader>

      {vehicles?.length > 10 ? (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={11}>
            <Box my={2} mt={5}>
              <Typography variant="h6">
                ¿Qué vehículo querés consultar?
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={11}>
            <VehicleList baseUrl="/endorsements/vehicle/details/" />
          </Grid>
        </Grid>
      ) : (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={11}>
            <Box my={2} mt={5}>
              <Typography variant="h6">
                ¿Qué vehículo querés consultar?
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={11}>
            <VehicleCards baseUrl="/endorsements/vehicle/details/" />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Endorsements;
